import React from "react";
import { useNavigate } from "react-router-dom";

import {
  FaHome,
  FaMale,
  FaFemale,
  FaShoppingBag,
} from "react-icons/fa";

import "./IconSlide.css";

function IconSlider() {
  const navigate = useNavigate();

  return (
    <div className="icon-slider">
      <div className="icon-track">

        {/* HOME */}
        <div
          className="icon-item"
          onClick={() => navigate("/")}
          style={{ cursor: "pointer" }}
        >
          <FaHome />
          <span>Home</span>
        </div>

        {/* <div className="icon-item">
          <FaGift />
          <span>Gift</span>
        </div> */}

        {/* <div className="icon-item">
          <FaTshirt />
          <span>Dresses</span>
        </div> */}

        {/* MEN */}
        <div
          className="icon-item"
          onClick={() => navigate("/mens")}
          style={{ cursor: "pointer" }}
        >
          <FaMale />
          <span>Men</span>
        </div>

        {/* WOMEN */}
        <div
          className="icon-item"
          onClick={() => navigate("/view-all")}
          style={{ cursor: "pointer" }}
        >
          <FaFemale />
          <span>Women</span>
        </div>

        {/* ACCESSORIES */}
        <div
          className="icon-item"
          onClick={() => navigate("/view-all")}
          style={{ cursor: "pointer" }}
        >
          <FaShoppingBag />
          <span>Accessories</span>
        </div>


        {/* duplicate for smooth loop */}

        {/* HOME */}
        <div
          className="icon-item"
          onClick={() => navigate("/")}
          style={{ cursor: "pointer" }}
        >
          <FaHome />
          <span>Home</span>
        </div>

        {/* <div className="icon-item">
          <FaGift />
          <span>Gift</span>
        </div>

        <div className="icon-item">
          <FaTshirt />
          <span>Dresses</span>
        </div> */}

        {/* MEN */}
        <div
          className="icon-item"
          onClick={() => navigate("/mens")}
          style={{ cursor: "pointer" }}
        >
          <FaMale />
          <span>Men</span>
        </div>

        {/* WOMEN */}
        <div
          className="icon-item"
          onClick={() => navigate("/view-all")}
          style={{ cursor: "pointer" }}
        >
          <FaFemale />
          <span>Women</span>
        </div>

        {/* ACCESSORIES */}
        <div
          className="icon-item"
          onClick={() => navigate("/Jewellery")}
          style={{ cursor: "pointer" }}
        >
          <FaShoppingBag />
          <span>Accessories</span>
        </div>

      </div>
    </div>
  );
}

export default IconSlider;